import type { RegistrationProgressResponse } from './status-display';

function readStringField(
  record: Record<string, unknown> | null | undefined,
  key: string
): string | null {
  if (!record) {
    return null;
  }

  const value = record[key];
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

/** Reads registration_status including values not yet in the shared schema contract. */
export function readProgressRegistrationStatus(
  progress: RegistrationProgressResponse
): string {
  const record = progress as Record<string, unknown>;
  const status = record['registration_status'];

  if (typeof status === 'string') {
    return status;
  }

  return progress.registration_status;
}

export function isCompletedRegistrationStatus(
  progress: RegistrationProgressResponse
): boolean {
  return readProgressRegistrationStatus(progress) === 'completed';
}

/** Reads customer_number from progress/business until platform API exposes it in contract. */
export function readProgressCustomerNumber(
  progress: RegistrationProgressResponse
): string | null {
  const progressRecord = progress as Record<string, unknown>;
  const fromProgress = readStringField(progressRecord, 'customer_number');

  if (fromProgress) {
    return fromProgress;
  }

  const business = progress.business as Record<string, unknown> | null;
  return readStringField(business, 'customer_number');
}

export function isRejectedEntityReviewStatus(
  status?: RegistrationProgressResponse['sections']['business']['status']
): boolean {
  return (status as string | undefined) === 'need_revision';
}
